export default __webpack_public_path__ + "static/media/(4).a93f781b.jpg";